export default class StatusApi {
  constructor({ httpGet, httpPost, httpPut, httpDelete }) {
    this.httpGet = httpGet;
    this.httpPost = httpPost;
    this.httpPut = httpPut;
    this.httpDelete = httpDelete;
  }

  getStatus(params, httpConfig) {
    return this.httpGet('status', params, httpConfig);
  }

  sendAck() {}
}
